/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CorporateDirectorDetailsDTO } from './CorporateDirectorDetailsDTO';

export type CorporatePersonalDetailsRequestDTO = {
    directorDetails?: CorporateDirectorDetailsDTO;
    email: string;
    firstName: string;
    lastName: string;
    representativeRole: CorporatePersonalDetailsRequestDTO.representativeRole;
    userExternalId: string;
};

export namespace CorporatePersonalDetailsRequestDTO {

    export enum representativeRole {
        DIRECTOR = 'DIRECTOR',
        BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
        BOTH = 'BOTH',
        NONE = 'NONE',
    }


}
